import countries from 'i18n-iso-countries'
import enLocale from 'i18n-iso-countries/langs/en.json'

// Config to Eng by default
countries.registerLocale(enLocale)

export const US = 'US'

/**
 * Get all the available counries in the next format:
 * [{ code: 'US', name: 'United States of America' }, {...}]
 *
 * @returns
 */
export const getCountriesArray = () => {
  const countryNames = countries.getNames('en', { select: 'official' })
  const result = []
  if (!countryNames) {
    return result
  }
  Object.keys(countryNames).forEach((key) => {
    result.push({
      code: key,
      name: countryNames[key],
    })
  })
  return result
}

export const COUNTRIES = getCountriesArray()
